import * as yup from 'yup'

export const formSchema = yup.object().shape({
  company: yup.string().required('Seleção obrigatória'),
  organization: yup.string().required('Seleção obrigatória'),
  market: yup.string().required('Seleção obrigatória'),
  sector: yup.string().required('Seleção obrigatória'),
  office: yup.string().required('Seleção obrigatória'),
  region: yup.string().required('Seleção obrigatória'),
  zone: yup.string().required('Seleção obrigatória'),
  quotaMonth: yup.string().required('Seleção obrigatória'),
  initialDataLine: yup.string().required('Campo obrigatório'),
  initialSizeCol: yup.string().required('Campo obrigatório'),
  finalSizeCol: yup.string().required('Campo obrigatório'),
  initialClientCol: yup.string().required('Campo obrigatório'),
  finalClientCol: yup.string().required('Campo obrigatório')
})
